<template>
    <div class="dam-profile-card pb-3">
        <h5 class="card-detail-heading">{{$t('dam-profile.meteorological-station')}}</h5>
        <div class="card-detail-text mt-2 pb-4 text-center">
            <span>{{$t('dashboard.last_updated')}}</span>
            <span>{{'&nbsp;'}}</span>
            <span>{{date[0]}}</span>
            <span>{{'&nbsp;'}}</span>
            <span>{{$t('dashboard.on')}}</span>
            <span>{{'&nbsp;'}}</span>
            <span>{{date[1]}}</span>
            <span>{{'&nbsp;'}}</span>
            <span>{{$t('dashboard.year')}}</span>
            <span v-if="this.$i18n.locale === 'bg'">.</span>
        </div>
        <RightPanelContainerIcons :is-dam-origin="true"/>
    </div>
</template>

<script>
    // utils
    import {formatShortDateCard} from "../../utils/common";
    // components
    import RightPanelContainerIcons from "../dashboard/RightPanelContainerIcons";

    export default {
        name: 'ProfileDamMeteorologicalStation',
        components: {
            RightPanelContainerIcons
        },
        data() {
            return {
                date: formatShortDateCard()
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "src/assets/scss/_cardDetail";
</style>